import { render } from "./DashboardLoadingBar.vue?vue&type=template&id=2d505cbf&scoped=true"
import script from "./DashboardLoadingBar.vue?vue&type=script&lang=js"
export * from "./DashboardLoadingBar.vue?vue&type=script&lang=js"

import "./DashboardLoadingBar.vue?vue&type=style&index=0&id=2d505cbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d505cbf"]])

export default __exports__